<template>
  <div class="barcode-generator pa-6">
    <v-card max-width="800" class="mx-auto">
      <v-card-title>Генератор штрих-кодов</v-card-title>
      <v-card-text>
        <p><b>Начальный номер: {{firstNumber}}</b> (может изменится, если кто-то сгенерирует номера до Вас)</p>
<!--         <v-text-field
          v-model.number="firstNumber"
          label="Начальный номер"
          type="number"
          outlined
        ></v-text-field> -->

        <v-text-field
          v-model.number="countNumbers"
          label="Количество штрих-кодов"
          type="number"
          outlined
        ></v-text-field>
      </v-card-text>
      <v-card-actions>
        <v-btn color="primary" @click="saveNewFirstnumber">Сгенерировать</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import JsBarcode from 'jsbarcode';

export default {
  name: 'BarcodeGenerator',
  data() {
    return {
      firstNumber: 100,
      countNumbers: 20,
    };
  },
  created(){
    this.init()
  },
  methods: {
    init(loopback=false){
        let t=this
        document.title='Генератор штрих-кодов';
        t.$http.get(`${BackendBase}/delivery/barcode-generator/init`).then(
            r=>{
                let d=r.data
                if(d.success){
                    if(loopback){
                        loopback()
                    }
                    t.firstNumber=d.value
                }
            }
        )
    },
    saveNewFirstnumber(){
        let t=this
        t.init(()=>{
            t.$http.get(`${BackendBase}/delivery/barcode-generator/save-first-number/${t.firstNumber+t.countNumbers}`).then(
                r=>{
                    let d=r.data
                    console.log('d:',d)
                    if(d.success){
                        console.log('generateBarcodes begin')
                        t.generateBarcodes()
                        console.log('generateBarcodes end')
                        t.firstNumber=d.value

                    }
                }

            )
        })

    },
    generateBarcodes() {

      const start = parseInt(this.firstNumber);
      const count = parseInt(this.countNumbers);

      if (isNaN(start) || isNaN(count) || count <= 0) {
        alert('Пожалуйста, введите корректные значения.');
        return;
      }

      // Создаём массив номеров
      const numbers = [];
      for (let i = 0; i < count; i++) {
        numbers.push(start + i);
      }

      // Генерируем HTML для печати
      this.openPrintPreview(numbers);
    },
openPrintPreview(numbers) {
  const printWindow = window.open('', '_blank', 'width=800,height=600');

  // Генерация изображений штрих-кодов
  const barcodeElements = numbers.map(num => {
    const canvas = document.createElement('canvas');
    JsBarcode(canvas, num.toString(), {
      format: 'CODE128',
      displayValue: true,
      fontSize: 16,
      width: 2,
      height: 40,
    });
    return canvas.toDataURL();
  });

  const html = `
    <html>
      <head>
        <title>Печать штрих-кодов</title>
        <style>
          @page {
            size: 7.5cm 11.5cm;
            margin: 1cm 0 0 0;

          }
          body {
            margin: 0;
            padding: 0.1cm;
            font-family: Arial, sans-serif;
          }
          .container {
            width: 7.5cm;
            height: 11.5cm;
            margin: 0 auto; /* по центру страницы по ширине */
          }
          .barcode-item {
            text-align: center;
            margin: 0 0 1.9cm 0; /* отступ между штрих-кодами */
            break-inside: avoid; /* не разрывать внутри */
          }
          .barcode-item:nth-child(3n) {
            break-after: page;
            margin-bottom: 4px;
          }
          .barcode-item:last-child {
            break-after: auto;
          }
          img {
            max-width: 90%;
            height: auto;
          }
        </style>
      </head>
      <body>
        <div class="container">
          ${barcodeElements.map(src => `
            <div class="barcode-item">
              <img src="${src}" alt="Barcode" />
            </div>
          `).join('')}
        </div>
      </body>
    </html>
  `;

  printWindow.document.write(html);
  printWindow.document.close();

  printWindow.onload = () => {
    printWindow.print();
  };
},
    // openPrintPreview(numbers) {
    //   // Создаём новое окно
    //   const printWindow = window.open('', '_blank', 'width=800,height=600');

    //   // Генерация SVG штрих-кодов через JsBarcode
    //   const barcodeElements = numbers.map(num => {
    //     const canvas = document.createElement('canvas');
    //     JsBarcode(canvas, num.toString(), {
    //       format: 'CODE128',
    //       displayValue: true,
    //       fontSize: 16,
    //       width: 2,
    //       height: 40,
    //     });
    //     return canvas.toDataURL(); // конвертируем в изображение
    //   });

    //   // Генерация HTML с нужным форматом страницы
    //   /*page-break-after: always;*/
    //     const html = `
    //       <html>
    //         <head>
    //           <title>Печать штрих-кодов</title>
    //           <style>
    //             @page {
    //               size: 7.5cm 11.5cm;
    //               margin: 0;
    //             }
    //             body {
    //               margin: 0;
    //               padding: 0.1cm;
    //               font-family: Arial, sans-serif;
    //             }
    //             .page {
    //               width: 7.5cm;
    //               height: 11.5cm;

    //               display: flex;
    //               flex-direction: column;
    //               justify-content: center;
    //               align-items: center;
    //               text-align: center;
    //               box-sizing: border-box;
    //             }
    //             .barcode {
    //               margin: 0 0 2px;
    //             }
    //             img {
    //               max-width: 90%;
    //               height: auto;
    //             }
    //           </style>
    //         </head>
    //         <body>
    //           ${Array.from(
    //             { length: Math.ceil(numbers.length / 3) },
    //             (_, pageIndex) => {
    //               const start = pageIndex * 3;
    //               const end = start + 3;
    //               const pageNumbers = numbers.slice(start, end);
    //               const pageBarcodes = barcodeElements.slice(start, end);

    //               return `
    //                 <div class="page">
    //                   ${pageBarcodes.map(src => `
    //                     <img src="${src}" class="barcode" alt="Barcode" />
    //                   `).join('')}
    //                 </div>
    //               `;
    //             }
    //           ).join('')}
    //         </body>
    //       </html>
    //     `;

    //   printWindow.document.write(html);
    //   printWindow.document.close();

    //   // После загрузки — показываем диалог печати
    //   printWindow.onload = () => {
    //     //printWindow.print();
    //   };
    // }
  }
};
</script>

<style scoped>
.barcode-generator {
  background-color: #f5f5f5;
  min-height: 100vh;
}
</style>